(function () {
  "use strict";
  var S = window.SHIRO_SURVEY_SETTINGS || {};
  var SURVEY = window.SHIRO_SURVEY || { questions: [] };
  var root = document.getElementById("shiro-survey");
  if (!root || !SURVEY.questions.length) return;
  var PROVISIONAL_TOTAL = 9;

  function withinDateRange() {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    if (S.startDate) { var s = new Date(S.startDate + "T00:00:00"); if (today < s) return false; }
    if (S.endDate) { var e = new Date(S.endDate + "T23:59:59"); if (today > e) return false; }
    return true;
  }
  // 閉じただけ→既定1時間で再表示。送信済み→永続で出さない。
  var DISMISS_COOLDOWN_MS = (function () { var n = parseInt(S.dismissCooldownMs, 10); return isNaN(n) ? 3600000 : n; })();
  function alreadyHandled() {
    try {
      if (localStorage.getItem(S.submitKey) === "1") return true;
      var d = localStorage.getItem(S.dismissKey);
      if (d) { var t = parseInt(d, 10); if (!isNaN(t) && (Date.now() - t) < DISMISS_COOLDOWN_MS) return true; }
      return false;
    } catch (e) { return false; }
  }
  function markDismissed() { try { localStorage.setItem(S.dismissKey, String(Date.now())); } catch (e) {} }
  function markSubmitted() { try { localStorage.setItem(S.submitKey, "1"); } catch (e) {} }
  var shouldAutoOpen = S.forceOpen === true || (S.enabled !== false && withinDateRange() && !alreadyHandled());

  var overlay = root.querySelector(".shiro-survey__overlay");
  var panelEmail = root.querySelector('[data-panel="email"]');
  var panelSurvey = root.querySelector('[data-panel="survey"]');
  var panelSuccess = root.querySelector('[data-panel="success"]');
  var emailInput = root.querySelector("#shiro-survey-email");
  var emailError = root.querySelector("#shiro-survey-email-error");
  var startBtn = root.querySelector('[data-action="start"]');
  var nextBtn = root.querySelector('[data-action="next"]');
  var backBtn = root.querySelector('[data-action="back"]');
  var submitError = root.querySelector("#shiro-survey-submit-error");
  var questionsWrap = root.querySelector("#shiro-survey-questions");
  var progressFill = root.querySelector(".shiro-progress__fill");
  var progressX = root.querySelector("[data-progress-x]");
  var progressN = root.querySelector("[data-progress-n]");
  var closeBtns = root.querySelectorAll('[data-action="close"]');
  var currentStep = 0, lastFocus = null;
  var NEXT_LABEL = S.nextLabel || "Next";
  var SUBMIT_LABEL = S.submitLabel || "Submit & get my 10% off";

  function open() {
    lastFocus = document.activeElement; root.hidden = false;
    document.body.style.overflow = "hidden";
    if (!panelEmail.hidden && emailInput) emailInput.focus();
    document.addEventListener("keydown", onKeydown);
  }
  function close(reason) {
    root.hidden = true; document.body.style.overflow = "";
    document.removeEventListener("keydown", onKeydown);
    if (reason === "dismiss") markDismissed();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKeydown(e) { if (e.key === "Escape") close("dismiss"); }
  Array.prototype.forEach.call(closeBtns, function (b) { b.addEventListener("click", function () { close("dismiss"); }); });
  if (overlay) { overlay.addEventListener("click", function (e) { if (e.target === overlay) close("dismiss"); }); }

  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  if (startBtn) {
    startBtn.addEventListener("click", function () {
      var val = (emailInput.value || "").trim();
      if (!isValidEmail(val)) { emailError.hidden = false; emailInput.focus(); return; }
      emailError.hidden = true; goToSurvey();
    });
  }
  function goToSurvey() {
    panelEmail.hidden = true; panelSurvey.hidden = false;
    if (!questionsWrap.dataset.rendered) { renderQuestions(); questionsWrap.dataset.rendered = "1"; questionsWrap.addEventListener("change", updateProgress); }
    showStep(0);
  }

  function renderQuestions() {
    SURVEY.questions.forEach(function (q, i) {
      var fs = document.createElement("fieldset");
      fs.className = "shiro-q"; fs.setAttribute("data-qid", q.id); fs.setAttribute("data-type", q.type);
      if (q.maxSelect) fs.setAttribute("data-max", String(q.maxSelect));
      if (q.required) fs.setAttribute("data-required", "1");
      fs.hidden = true;
      var legend = document.createElement("legend"); legend.className = "shiro-q__legend";
      var num = document.createElement("span"); num.className = "shiro-q__num"; num.textContent = "Q" + (i + 1); legend.appendChild(num);
      var t = document.createElement("span"); t.className = "shiro-q__title";
      t.innerHTML = esc(q.label) + (q.labelEn ? '<span class="shiro-q__en">' + esc(q.labelEn) + "</span>" : ""); legend.appendChild(t);
      var meta = document.createElement("span"); meta.className = "shiro-q__meta";
      meta.innerHTML = (q.required ? '<span class="shiro-q__req">Required</span>' : '<span class="shiro-q__opt">Optional</span>') + (q.note ? '<span class="shiro-q__note">' + esc(q.note) + "</span>" : "");
      legend.appendChild(meta); fs.appendChild(legend);
      var list = document.createElement("div"); list.className = "shiro-q__options";
      if (q.type === "select") { renderSelect(q, list); }
      else {
        q.options.forEach(function (opt, j) {
          var lbl = document.createElement("label"); lbl.className = "shiro-opt";
          var input = document.createElement("input");
          input.type = q.type === "single" ? "radio" : "checkbox";
          input.name = q.id; input.id = q.id + "_" + j; input.value = opt.value; input.setAttribute("data-label", opt.label);
          lbl.appendChild(input);
          var span = document.createElement("span"); span.className = "shiro-opt__text"; span.textContent = opt.label;
          lbl.appendChild(span); list.appendChild(lbl);
          if (opt.hasText) {
            var text = document.createElement("input"); text.type = "text"; text.className = "shiro-opt__other";
            text.placeholder = "Please specify"; text.setAttribute("data-other-for", q.id); text.maxLength = 300; text.hidden = true;
            list.appendChild(text);
            input.addEventListener("change", function () { text.hidden = !input.checked; if (input.checked) text.focus(); });
          }
          if (q.type === "multi" && q.maxSelect) { input.addEventListener("change", function () { enforceMax(fs, q.maxSelect); }); }
          if (q.type === "single") { input.addEventListener("change", function () { syncOtherInputs(list); }); }
        });
      }
      fs.appendChild(list);
      var err = document.createElement("p"); err.className = "shiro-q__error"; err.hidden = true; err.textContent = "Please answer this question.";
      fs.appendChild(err); questionsWrap.appendChild(fs);
    });
  }
  function syncOtherInputs(list) {
    Array.prototype.forEach.call(list.querySelectorAll(".shiro-opt"), function (lbl) {
      var input = lbl.querySelector("input"); var other = lbl.nextElementSibling;
      if (other && other.classList && other.classList.contains("shiro-opt__other")) other.hidden = !input.checked;
    });
  }
  function renderSelect(q, list) {
    var sel = document.createElement("select"); sel.className = "shiro-select"; sel.name = q.id;
    var ph = document.createElement("option"); ph.value = ""; ph.textContent = S.selectPlaceholder || "Please select…"; ph.disabled = true; ph.selected = true; sel.appendChild(ph);
    var hasOther = false;
    q.options.forEach(function (opt) {
      var o = document.createElement("option"); o.value = opt.value; o.textContent = opt.label; o.setAttribute("data-label", opt.label);
      if (opt.hasText) hasOther = true; sel.appendChild(o);
    });
    list.appendChild(sel);
    var text = null;
    if (hasOther) { text = document.createElement("input"); text.type = "text"; text.className = "shiro-opt__other"; text.placeholder = "Please specify"; text.setAttribute("data-other-for", q.id); text.maxLength = 300; text.hidden = true; list.appendChild(text); }
    sel.addEventListener("change", function () { if (text) { var chosen = q.options.filter(function (o) { return o.value === sel.value; })[0]; text.hidden = !(chosen && chosen.hasText); if (!text.hidden) text.focus(); } });
  }
  function enforceMax(fs, max) {
    var boxes = fs.querySelectorAll('input[type="checkbox"]');
    var checked = fs.querySelectorAll('input[type="checkbox"]:checked').length;
    Array.prototype.forEach.call(boxes, function (b) { b.disabled = !b.checked && checked >= max; });
  }

  function computePath() { return SURVEY.questions.filter(function (q) { return !q.showIf || evalShowIf(q.showIf); }); }
  function evalShowIf(cond) { var picked = getValues(cond.questionId); return picked.some(function (v) { return cond.in.indexOf(v) !== -1; }); }
  function getValues(qid) {
    var fs = questionsWrap.querySelector('[data-qid="' + qid + '"]'); if (!fs) return [];
    var sel = fs.querySelector("select"); if (sel) return sel.value ? [sel.value] : [];
    return Array.prototype.map.call(fs.querySelectorAll("input:checked"), function (i) { return i.value; });
  }
  function q2Answered() { return getValues("q2").length > 0; }
  function computeDenominator() { return q2Answered() ? computePath().length : PROVISIONAL_TOTAL; }
  function showStep(pos) {
    var path = computePath();
    if (pos < 0) pos = 0; if (pos > path.length - 1) pos = path.length - 1;
    currentStep = pos;
    Array.prototype.forEach.call(questionsWrap.querySelectorAll(".shiro-q"), function (fs) { fs.hidden = true; });
    var cur = path[pos]; var curFs = questionsWrap.querySelector('[data-qid="' + cur.id + '"]');
    curFs.hidden = false;
    var num = curFs.querySelector(".shiro-q__num"); if (num) num.textContent = "Q" + (pos + 1);
    updateProgress();
    backBtn.hidden = pos === 0;
    nextBtn.textContent = (pos === path.length - 1) ? SUBMIT_LABEL : NEXT_LABEL;
    submitError.hidden = true; panelSurvey.scrollTop = 0;
  }
  function updateProgress() {
    var n = computeDenominator(); var x = currentStep + 1; if (x > n) x = n;
    if (progressX) progressX.textContent = String(x);
    if (progressN) progressN.textContent = String(n);
    if (progressFill) progressFill.style.width = Math.round((x / n) * 100) + "%";
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      var path = computePath(); var cur = path[currentStep];
      if (!validateQuestion(cur)) return;
      path = computePath();
      if (currentStep >= path.length - 1) { doSubmit(path); return; }
      showStep(currentStep + 1);
    });
  }
  if (backBtn) { backBtn.addEventListener("click", function () { if (currentStep > 0) showStep(currentStep - 1); }); }
  function validateQuestion(q) {
    var fs = questionsWrap.querySelector('[data-qid="' + q.id + '"]');
    var err = fs.querySelector(".shiro-q__error"); err.hidden = true;
    var sel = fs.querySelector("select");
    if (sel) { if (q.required && !sel.value) { err.hidden = false; return false; } return true; }
    var checked = fs.querySelectorAll("input:checked");
    if (q.required && checked.length === 0) { err.hidden = false; return false; }
    return true;
  }
  function collectPath(path) {
    var flat = {};
    path.forEach(function (q) {
      var fs = questionsWrap.querySelector('[data-qid="' + q.id + '"]');
      var sel = fs.querySelector("select");
      if (sel) {
        if (sel.value) { var o = sel.options[sel.selectedIndex]; flat[q.id] = o.getAttribute("data-label") || o.textContent; var so = fs.querySelector(".shiro-opt__other"); if (so && !so.hidden) flat[q.id + "_other"] = (so.value || "").trim(); }
        return;
      }
      var checked = fs.querySelectorAll("input:checked");
      flat[q.id] = Array.prototype.map.call(checked, function (i) { return i.getAttribute("data-label"); }).join(" | ");
      var ot = fs.querySelector(".shiro-opt__other:not([hidden])"); if (ot) flat[q.id + "_other"] = (ot.value || "").trim();
    });
    return flat;
  }
  function doSubmit(path) {
    var flat = collectPath(path);
    var payload = Object.assign({ email: (emailInput.value || "").trim(), consent: true, source: "survey-popup", surveyVersion: SURVEY.version || "", clientSubmittedAt: new Date().toISOString(), page: location.pathname, userAgent: navigator.userAgent }, flat);
    nextBtn.disabled = true; nextBtn.textContent = S.submittingLabel || "Sending…";
    send(payload).then(showSuccess).catch(showSuccess);
  }
  function send(payload) {
    if (!S.gasUrl) { console.warn("[shiro-survey] preview mode. payload:", payload); return Promise.resolve(); }
    return fetch(S.gasUrl, { method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: JSON.stringify(payload) });
  }
  function showSuccess() { markSubmitted(); panelSurvey.hidden = true; panelSuccess.hidden = false; }

  function reset() {
    panelSurvey.hidden = true; panelSuccess.hidden = true; panelEmail.hidden = false;
    if (emailInput) emailInput.value = "";
    if (nextBtn) { nextBtn.disabled = false; nextBtn.textContent = NEXT_LABEL; }
    if (questionsWrap.dataset.rendered) {
      Array.prototype.forEach.call(questionsWrap.querySelectorAll("input"), function (i) { if (i.type === "text") { i.value = ""; i.hidden = true; } else { i.checked = false; i.disabled = false; } });
      Array.prototype.forEach.call(questionsWrap.querySelectorAll("select"), function (s) { s.selectedIndex = 0; });
    }
    try { localStorage.removeItem(S.dismissKey); localStorage.removeItem(S.submitKey); } catch (e) {}
  }
  function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }
  var delay = parseInt(S.showDelayMs, 10); if (isNaN(delay)) delay = 1200;
  window.ShiroSurvey = { open: open, close: close, reset: reset };
  if (shouldAutoOpen) window.setTimeout(open, delay);
})();